import React, { memo } from "react";
import { Fonts, FontWeights, FontColors } from "theme/fontConfig";

const styles = {
  body: {
    fontSize: Fonts.GeneralBodyFont.fontSize,
    textAlign: "start",
  },
};

export const LabelField = memo(
  ({
    className,
    title,
    htmlFor,
    style,
    mandatory = false,
    children,
    labelClassName,
    ...rest
  }) => {
    return (
      <div
        className={`d-felx justify-content-start text-truncate mb-1 ${className}`}
        style={{ ...style }}
      >
        <label
          style={{ ...styles.body, fontWeight: FontWeights.Medium }}
          {...{ htmlFor }}
          {...rest}
          className={labelClassName}
        >
          {title || children}
        </label>
        {mandatory && (
          <label
            style={{ ...styles.body, fontWeight: FontWeights.Medium, color: FontColors.Red }}
            {...{ htmlFor }}
            {...rest}
          >
            {" *"}
          </label>
        )}
      </div>
    );
  }
);
